module.exports = __webpack_public_path__ + "img/10c6a1a.jpg";